<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useAuthedImage } from "@/shared/lib/composables/useAuthedImage";

const { t } = useI18n();

const props = defineProps({
  participant: {
    type: Object,
    required: true,
  },
  participantTypes: {
    type: Array,
    default: () => [],
  },
});

const fullName = computed(() => {
  return [
    props.participant.first_name,
    props.participant.last_name,
    props.participant?.middle_name,
  ]
    .filter(Boolean)
    .join(" ");
});

function getParticipantTypeLabel(code) {
  if (!code) return t("Участник");
  if (props.participant.participant_type_code_info?.name) {
    return props.participant.participant_type_code_info.name;
  }
  if (!props.participantTypes) return code;
  let reference = props.participantTypes.find(
    (participant) => participant.code === code
  );
  return reference ? `${reference.name}` : code;
}

const { src: photoSrc, error: photoError } = useAuthedImage(
  () => props.participant.person_photo
);
</script>

<template>
  <div class="flex gap-4 items-start">
    <img
      v-if="photoSrc && !photoError"
      :src="photoSrc"
      alt="img"
      class="rounded-xl border border-border object-cover flex items-center justify-center"
      style="width: 72px; height: 88px"
      @error="photoError = true"
    />
    <div v-else class="empty">
      <svg-icon name="huge-user" class="w-6 h-16 text-muted-foreground" />
    </div>

    <div class="flex-1 flex flex-col gap-2">
      <div class="flex flex-col gap-1">
        <span class="text-muted-foreground text-xs leading-4"> ФИО </span>

        <div class="flex justify-between items-center gap-4">
          <span class="text-foreground text-sm font-semibold leading-5">
            {{ fullName }}
          </span>

          <span
            class="text-foreground text-sm font-normal leading-5 whitespace-nowrap"
          >
            {{ getParticipantTypeLabel(participant.participant_type_code) }}
          </span>
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-muted-foreground text-xs leading-4"> ИИН </span>

        <span class="text-foreground text-sm leading-5">
          {{ participant.identifier || $t("Не указано") }}
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.empty {
  @apply w-[72px] h-[88px] flex justify-center items-center bg-muted/50;
  @apply rounded-xl border border-border;
}
</style>
